import PropTypes from 'prop-types';
export const contentV2PropTypes = {
  description: PropTypes.string
};